import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';
import { AddressTypeReferenceModel } from '../../models/reference-model/reference-general-model/';


@Injectable({
    providedIn: 'root'
})
export class AddressTypeReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/AddressTypeReferences"
    private _addressTypeReference = new BehaviorSubject<AddressTypeReferenceModel[]>(null);

    get addressTypeReference() {
        return this._addressTypeReference.asObservable();
    }

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getAddressTypeReferences(): Observable<AddressTypeReferenceModel[]> {
        return this.httpGet<AddressTypeReferenceModel[]>(this.PATH, null)
            .pipe(
                tap(res => this._addressTypeReference.next(res.body)),
                map(res => res.body)
            )
    }
}